import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FcpBadgeModule, FcpIconModule } from 'fc-ui-components';

import { FauxInputButtonComponent } from './faux-input-button.component';

@NgModule({
    declarations: [FauxInputButtonComponent],
    imports: [CommonModule, TranslateModule, FcpIconModule, FcpBadgeModule],
    exports: [FauxInputButtonComponent]
})
export class FauxInputButtonModule {}
